import { SaveResponse } from "src/models/api/save";
import { ExpenseReportDTO } from "../../models/expense-reports/expense-report-dto";
import { ExpenseReportSTO } from "../../models/expense-reports/expense-report-sto";
import { BaseApiService } from "../base";
import { ExpenseReportsApprovalFilter } from "src/models/expense-reports/expense-reports-approval-filter";
import { LoadResponse } from "src/models/api/load";
import { PreApproveExpenseReportDTO } from "src/models/pre-approve-expense-report/pre-approve-expense-report";

export class ExpenseReportsApiService extends BaseApiService<ExpenseReportDTO, ExpenseReportSTO> {
  constructor() {
    super({
      servicePath: "/ExpenseReports",
      loadItemsPath: "/GetExpenseReports",
      saveItemsPath: "/SaveExpenseReports",
    });
  }
}

export const approveExpenseReports = async (
  expenseReportsPropsFilter: ExpenseReportsApprovalFilter
): Promise<LoadResponse<ExpenseReportDTO>> => {
  const apiService = new ExpenseReportsApiService();
  apiService.useLoadItemsPath("/ApproveExpenseReports");
  const response = apiService.loadItems({
    ...expenseReportsPropsFilter,
  });

  return response;
};

export const approveExpenseReportsByLink = async (
  expenseReportsPropsFilter: ExpenseReportsApprovalFilter
): Promise<LoadResponse<ExpenseReportDTO>> => {
  const apiService = new ExpenseReportsApiService();
  apiService.useLoadItemsPath("/ApproveExpenseReportsByLink");
  const response = apiService.loadItems({
    ...expenseReportsPropsFilter,
  });
  return response;
};

export const rejectExpenseReports = async (
  expenseReportsPropsFilter: ExpenseReportsApprovalFilter
): Promise<LoadResponse<ExpenseReportDTO>> => {
  const apiService = new ExpenseReportsApiService();
  apiService.useLoadItemsPath("/RejectExpenseReports");
  const response = apiService.loadItems({
    ...expenseReportsPropsFilter,
  });
  return response;
};

export const rejectExpenseReportsByLink = async (
  expenseReportsPropsFilter: ExpenseReportsApprovalFilter
): Promise<LoadResponse<ExpenseReportDTO>> => {
  const apiService = new ExpenseReportsApiService();
  apiService.useLoadItemsPath("/RejectExpenseReportsByLink");
  const response = apiService.loadItems({
    ...expenseReportsPropsFilter,
  });
  return response;
};

export const returnExpenseReportsBacktoEmployee = async (
  expenseReportsPropsFilter: ExpenseReportsApprovalFilter
): Promise<LoadResponse<ExpenseReportDTO>> => {
  const apiService = new ExpenseReportsApiService();
  apiService.useLoadItemsPath("/ReturnExpenseReportsBackToEmployee");
  const response = apiService.loadItems({
    ...expenseReportsPropsFilter,
  });
  return response;
};

export const markExpenseReportsAsPaid = async (
  expenseReportsPropsFilter: ExpenseReportsApprovalFilter
): Promise<LoadResponse<ExpenseReportDTO>> => {
  const apiService = new ExpenseReportsApiService();
  apiService.useLoadItemsPath("/MarkExpenseReportsAsPaid");
  const response = apiService.loadItems({
    ...expenseReportsPropsFilter,
  });

  return response;
};

export const approveExpenseReportsDocumentation = async (
  expenseReportsPropsFilter: ExpenseReportsApprovalFilter
): Promise<LoadResponse<ExpenseReportDTO>> => {
  const apiService = new ExpenseReportsApiService();
  apiService.useLoadItemsPath("/ApproveExpenseReportsDocumentation");
  const response = apiService.loadItems({
    ...expenseReportsPropsFilter,
  });

  return response;
};
